import { Box, Grid } from '@mui/material';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import MilestoneWidget from './MilestoneWidget';
import './summaryStyles.scss';
import StartupProgressWidget from './StartupProgressWidget';
import QueriesWidget from './QueriesWidget';
import EssentialDocumentsWidget from './EssentialDocumentsWidget';
import summaryStaticWidgetData from 'src/resources/static.json';

export const Summary: React.FC = () => {
  const { checkPermission } = usePermissionWrapper();

  return (
    <>
      {checkPermission('view_tsda_startup_summary') && (
        <Box sx={{ mt: 2, ml: 4 }}>
          <Grid container spacing={4} justifyContent="space-between">
            {checkPermission('view_tsda_startup_summary_startup_progress') && (
              <StartupProgressWidget
                startupProgressData={summaryStaticWidgetData.summaryWidgetData.start_up_progress}
              />
            )}
            <Grid
              item
              xs={7.5}
              spacing={2}
              justifyContent="space-between"
              style={{ paddingLeft: '18px', paddingTop: '0px' }}
            >
              <Box
                style={{
                  border: '1px solid #efefef',
                  paddingLeft: '8px',
                  paddingTop: '16px',
                  marginBottom: '16px',
                  borderRadius: '4px'
                }}
              >
                {checkPermission('view_tsda_startup_summary_milestone_progress') && <MilestoneWidget />}
              </Box>
              <Box style={{ border: '1px solid #efefef', paddingLeft: '8px', paddingTop: '16px', borderRadius: '4px' }}>
                {checkPermission('view_tsda_startup_summary_queries') && (
                  <>{<QueriesWidget queriesObjStatic={summaryStaticWidgetData.summaryWidgetData.queries} />}</>
                )}
                {/* {tasksWidget()} */}
                {checkPermission('view_tsda_startup_summary_essential_documents') &&
                  summaryStaticWidgetData.summaryWidgetData.essential_documents && (
                    <>
                      {
                        <EssentialDocumentsWidget
                          essentialWidgetStatic={summaryStaticWidgetData.summaryWidgetData.essential_documents}
                        />
                      }
                    </>
                  )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};
